import React, { useEffect, useState } from "react";

// Reste à mettre le domaine dynamique suivant la configuration recette / prod

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })} à ${date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;
};

const DerniereLivraison = ({ idFournisseur }) => {
  const [lastDelivery, setLastDelivery] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!idFournisseur) {
          return;
    }


    const fetchLastDelivery = async () => {
      setLoading(true);
      try {
        const response = await fetch(
         `https://api.marion-materiaux.com/api/fo/last-delivery/${idFournisseur}`,
         {
           headers: {
             "Authorization": `Bearer ${token}`,
             "Accept": "application/json"

            }
          }
        );

        if (!response.ok) {
          throw new Error(`Erreur HTTP : ${response.status}`);
        }

        const data = await response.json();
        setLastDelivery(data);
      } catch (error) {
        console.error("Erreur lors de la récupération de la dernière livraison :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLastDelivery();
  }, [idFournisseur]);

  return (
    <>
    {lastDelivery && (
    <div className="ifs-4 p-3 mb-4 border rounded bg-light">
      Ta dernière demande de livraison

      {loading && (
        <div className="placeholder-glow">
          <div className="placeholder col-6 mb-2"></div>
          <div className="placeholder col-8 mb-2"></div>
          <div className="placeholder col-4"></div>
        </div>
      )}

      {!loading && lastDelivery && (
        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
          <p><strong>Adresse de livraison :</strong> {lastDelivery.AdresseLivraison}</p>
          <p><strong>Date demande :</strong> {formatDateTime(lastDelivery.DateCommande)}</p>
          <p><strong>Client :</strong> {lastDelivery.RaisonSocialClient}</p>
          <p><strong>Total HT :</strong> {lastDelivery.livraisonHT || '0,00'} €</p>
        </div>
      )}

      {!loading && !lastDelivery && (
        <small className="text-muted">Tu n'as pas encore passé commande</small>
      )}
    </div>
    )}
   </>
  );

};

export default DerniereLivraison;


